import { Box, IconButton, SxProps, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { navigateTo } from '@services/navigation';
import styles from './styles';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import HeadingArrowWrapper from '../heading-arrow-wrapper';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { pathnameToText } from '@components/layout/top-bar/data';

interface TopBackBtnWrapperProps {
  title?: string;
  onBackClick?: VoidFunction;
  wrapperSx?: SxProps;
  iconBtnSx?: SxProps;
  iconSx?: SxProps;
}

/**
 * TODO: Use @see {@link HeadingArrowWrapper} instead of this component at most places. Remove callback fn in HeadingArrowWrapper in onBackClick.
 * make one object to render routes in app.tsx and labels in @see {@link pathnameToText} respectively.
 */
function TopBackBtnWrapper(props: TopBackBtnWrapperProps) {
  const { title, onBackClick, wrapperSx, iconBtnSx, iconSx } = props;
  return (
    <Box sx={{ ...styles.topRow, ...wrapperSx }}>
      <IconButton
        sx={{ height: '2.8rem', width: '2.8rem', backgroundColor: '#F5F5F5', ...iconBtnSx }}
        onClick={() => {
          if (onBackClick) {
            onBackClick();
          } else {
            navigateTo(-1);
          }
        }}>
        <ArrowBackIcon sx={{ height: '1.9rem', width: '1.9rem', color: 'font.dark', ...iconSx }} />
      </IconButton>
      {title && (
        <Typography variant="body1" sx={{ fontFamily: 'Poppins', fontWeight: '600' }}>
          {title}
        </Typography>
      )}
    </Box>
  );
}

export default TopBackBtnWrapper;
